import { AddIcon } from './icons/add.icon';
import { AddDuplicateSolidIcon } from './icons/add_duplicate-solid.icon';
import { AlignCenterIcon } from './icons/align_center.icon';
import { AlignLeftIcon } from './icons/align_left.icon';
import { AlignRightIcon } from './icons/align_right.icon';
import { AnimatedSparklesIcon } from './icons/animated_sparkles.icon';
import { ArrowHorizontalIcon } from './icons/arrow_horizontal.icon';
import { ArrowLeftStartOnRectangleIcon } from './icons/arrow_left_start_on_rectangle.icon';
import { ArrowMergeIcon } from './icons/arrow_merge.icon';
import { ArrowRightStartOnRectangleIcon } from './icons/arrow_right_start_on_rectangle.icon';
import { ArrowSplitIcon } from './icons/arrow_split.icon';
import { ArrowUpRightIcon } from './icons/arrow_up_right.icon';
import { ArrowsRightLeftIcon } from './icons/arrows_right_left.icon';
import { AttachmentIcon } from './icons/attachment.icon';
import { BanIcon } from './icons/ban.icon';
import { BellAlertIcon } from './icons/bell_alert.icon';
import { BellSolidIcon } from './icons/bell_solid.icon';
import { BoltIcon } from './icons/bolt.icon';
import { BookOpenIcon } from './icons/book_open.icon';
import { BrainIcon } from './icons/brain.icon';
import { ChangeIcon } from './icons/change.icon';
import { ChartBarIcon } from './icons/chart_bar.icon';
import { ChartBarSquareIcon } from './icons/chart_bar_square.icon';
import { ChatBubbleLeftIcon } from './icons/chat_bubble_left.icon';
import { ChatBubbleLeftEllipsisIcon } from './icons/chat_bubble_left_ellipsis.icon';
import { CheckCircleSolidIcon } from './icons/check_circle_solid';
import { ChevronDownIcon } from './icons/chevron_down.icon';
import { ChevronRightIcon } from './icons/chevron_right.icon';
import { CircleIcon } from './icons/circle.icon';
import { ClockSolidIcon } from './icons/clock_solid.icon';
import { CloseIcon } from './icons/close.icon';
import { CogIcon } from './icons/cog.icon';
import { ConfirmIcon } from './icons/confirm.icon';
import { CubeTransparentIcon } from './icons/cube_transparent.icon';
import { DateIcon } from './icons/date.icon';
import { DeleteIcon } from './icons/delete.icon';
import { DeleteSolidIcon } from './icons/delete_solid.icon';
import { DeviceComputerIcon } from './icons/device_computer.icon';
import { DevicePhoneIcon } from './icons/device_phone.icon';
import { DeviceTabletIcon } from './icons/device_tablet.icon';
import { DisplayArrowInIcon } from './icons/display_arrow_in.icon';
import { DisplayArrowOutIcon } from './icons/display_arrow_out.icon';
import { DocumentChartBarIcon } from './icons/document_chart_bar.icon';
import { DownloadIcon } from './icons/download.icon';
import { EditIcon } from './icons/edit.icon';
import { ErrorIcon } from './icons/error.icon';
import { ExclamationTriangleSolidIcon } from './icons/exclamation_triangle_solid';
import { ExternalLinkIcon } from './icons/external_link.icon';
import { EyeSolidIcon } from './icons/eye_solid.icon';
import { FileDownloadSolidIcon } from './icons/file_download_solid.icon';
import { FilterIcon } from './icons/filter.icon';
import { FilterSolidIcon } from './icons/filter_solid.icon';
import { FlagIcon } from './icons/flag.icon';
import { FontSizeIcon } from './icons/font_size.icon';
import { FormatAlignListIcon } from './icons/format_align_list.icon';
import { FormatBoldIcon } from './icons/format_bold.icon';
import { FormatItalicsIcon } from './icons/format_italics.icon';
import { FormatListIcon } from './icons/format_list.icon';
import { FormatUnderlineIcon } from './icons/format_underline.icon';
import { HamburgerMenuIcon } from './icons/hamburger_menu.icon';
import { ImageIcon } from './icons/image.icon';
import { InfoIcon } from './icons/info.icon';
import { InfoCircleSolidIcon } from './icons/info_circle_solid';
import { KeyIcon } from './icons/key.icon';
import { LanguageIcon } from './icons/language.icon';
import { LinkIcon } from './icons/link.icon';
import { LockIcon } from './icons/lock.icon';
import { LockSolidIcon } from './icons/lock_solid.icon';
import { LogoutIcon } from './icons/logout.icon';
import { MenuIcon } from './icons/menu.icon';
import { NavArchiveIcon } from './icons/nav_archive.icon';
import { NavAssessmentsIcon } from './icons/nav_assessments.icon';
import { NavAuditTrailIcon } from './icons/nav_audit_trail.icon';
import { NavClientManagementIcon } from './icons/nav_client_management.icon';
import { NavCloseOutIcon } from './icons/nav_close_out.icon';
import { NavConfigurationIcon } from './icons/nav_configuration.icon';
import { NavConsentIcon } from './icons/nav_consent.icon';
import { NavCubeIcon } from './icons/nav_cube.icon';
import { NavDataIcon } from './icons/nav_data.icon';
import { NavDataTransferIcon } from './icons/nav_data_transfer.icon';
import { NavDeploymentIcon } from './icons/nav_deployment.icon';
import { NavHelpIcon } from './icons/nav_help.icon';
import { NavLibraryManagementIcon } from './icons/nav_library_management.icon';
import { NavLogIcon } from './icons/nav_log.icon';
import { NavParticipantsIcon } from './icons/nav_participants.icon';
import { NavProtocolIcon } from './icons/nav_protocol.icon';
import { NavQueriesIcon } from './icons/nav_queries.icon';
import { NavScheduleIcon } from './icons/nav_schedule.icon';
import { NavScreenshotIcon } from './icons/nav_screenshot.icon';
import { NavSitesIcon } from './icons/nav_sites.icon';
import { NavStudySetupIcon } from './icons/nav_study_setup.icon';
import { NavTeamIcon } from './icons/nav_team.icon';
import { NavTodoIcon } from './icons/nav_todo.icon';
import { NavTranslationsIcon } from './icons/nav_translations.icon';
import { NavUserManagementIcon } from './icons/nav_user_management.icon';
import { NavUsersIcon } from './icons/nav_users.icon';
import { NavWorkflowsIcon } from './icons/nav_workflows.icon';
import { NavWrenchScrewdriverIcon } from './icons/nav_wrench_screwdriver.icon';
import { NotificationIcon } from './icons/notification.icon';
import { OrderedListIcon } from './icons/ordered_list.icon';
import { PackageTruckIcon } from './icons/package_truck.icon';
import { PencilSolidIcon } from './icons/pencil-solid.icon';
import { PreviewIcon } from './icons/preview.icon';
import { ProfileIcon } from './icons/profile.icon';
import { QuestionIcon } from './icons/question.icon';
import { RectangleStackIcon } from './icons/rectangle_stack.icon';
import { RemoveIcon } from './icons/remove.icon';
import { SaveIcon } from './icons/save.icon';
import { SearchIcon } from './icons/search.icon';
import { SendIcon } from './icons/send.icon';
import { SendSolidIcon } from './icons/send_solid.icon';
import { SettingsIcon } from './icons/settings.icon';
import { ShareIcon } from './icons/share.icon';
import { SortDownIcon } from './icons/sort_down.icon';
import { SparklesIcon } from './icons/sparkles.icon';
import { SparklesSolidIcon } from './icons/sparkles_solid.icon';
import { SquaresIcon } from './icons/squares.icon';
import { SquaresSolidIcon } from './icons/squares_solid.icon';
import { StatusInProgressIcon } from './icons/status_in_progress.icon';
import { StatusInReviewIcon } from './icons/status_in_review.icon';
import { StatusNotStartedIcon } from './icons/status_not_started.icon';
import { StatusReadyIcon } from './icons/status_ready.icon';
import { StopCircleIcon } from './icons/stop_circle.icon';
import { SuccessIcon } from './icons/success.icon';
import { SuccessSolidIcon } from './icons/success_solid.icon';
import { TimeIcon } from './icons/time.icon';
import { UndoIcon } from './icons/undo.icon';
import { UnorderedListIcon } from './icons/unordered_list.icon';
import { UploadIcon } from './icons/upload.icon';
import { VideoIcon } from './icons/video.icon';
import { WarningIcon } from './icons/warning.icon';
import { WindowIcon } from './icons/window.icon';
import { XCircleIcon } from './icons/x_circle.icon';
import { XCircleSolidIcon } from './icons/x_circle_solid';
export const ICON_MAP = {
    add: { IconComponent: AddIcon },
    addDuplicateSolid: { IconComponent: AddDuplicateSolidIcon },
    alignCenter: { IconComponent: AlignCenterIcon },
    alignLeft: { IconComponent: AlignLeftIcon },
    alignRight: { IconComponent: AlignRightIcon },
    animatedSparkles: { IconComponent: AnimatedSparklesIcon },
    arrowBackward: { IconComponent: ArrowHorizontalIcon, supportsRTL: true },
    arrowForward: { IconComponent: ArrowHorizontalIcon, horizontalReverse: true, supportsRTL: true },
    arrowsRightLeft: { IconComponent: ArrowsRightLeftIcon },
    arrowLeftStartOnRectangle: { IconComponent: ArrowLeftStartOnRectangleIcon },
    arrowMerge: { IconComponent: ArrowMergeIcon },
    arrowRightStartOnRectangle: { IconComponent: ArrowRightStartOnRectangleIcon },
    arrowSplit: { IconComponent: ArrowSplitIcon },
    arrowUpRight: { IconComponent: ArrowUpRightIcon },
    attachment: { IconComponent: AttachmentIcon },
    ban: { IconComponent: BanIcon },
    bellAlert: { IconComponent: BellAlertIcon },
    bellSolid: { IconComponent: BellSolidIcon },
    bolt: { IconComponent: BoltIcon },
    bookOpen: { IconComponent: BookOpenIcon },
    brain: { IconComponent: BrainIcon },
    change: { IconComponent: ChangeIcon },
    chartBar: { IconComponent: ChartBarIcon },
    chartBarSquare: { IconComponent: ChartBarSquareIcon },
    chatBubbleLeft: { IconComponent: ChatBubbleLeftIcon, supportsRTL: true },
    chatBubbleLeftEllipsis: { IconComponent: ChatBubbleLeftEllipsisIcon, supportsRTL: true },
    checkCircleSolid: { IconComponent: CheckCircleSolidIcon },
    chevronDown: { IconComponent: ChevronDownIcon },
    chevronLeft: { IconComponent: ChevronRightIcon, horizontalReverse: true, supportsRTL: true },
    chevronRight: { IconComponent: ChevronRightIcon, supportsRTL: true },
    chevronUp: { IconComponent: ChevronDownIcon, verticalReverse: true },
    circle: { IconComponent: CircleIcon },
    clockSolid: { IconComponent: ClockSolidIcon },
    close: { IconComponent: CloseIcon },
    cog: { IconComponent: CogIcon },
    confirm: { IconComponent: ConfirmIcon },
    cubeTransparent: { IconComponent: CubeTransparentIcon },
    date: { IconComponent: DateIcon },
    delete: { IconComponent: DeleteIcon },
    deleteSolid: { IconComponent: DeleteSolidIcon },
    deviceComputer: { IconComponent: DeviceComputerIcon },
    devicePhone: { IconComponent: DevicePhoneIcon },
    deviceTablet: { IconComponent: DeviceTabletIcon },
    displayArrowIn: { IconComponent: DisplayArrowInIcon },
    displayArrowOut: { IconComponent: DisplayArrowOutIcon },
    download: { IconComponent: DownloadIcon },
    documentChartBar: { IconComponent: DocumentChartBarIcon },
    edit: { IconComponent: EditIcon },
    error: { IconComponent: ErrorIcon },
    exclamationTriangleSolid: { IconComponent: ExclamationTriangleSolidIcon },
    externalLink: { IconComponent: ExternalLinkIcon },
    eyeSolid: { IconComponent: EyeSolidIcon },
    fileDownloadSolid: { IconComponent: FileDownloadSolidIcon },
    filter: { IconComponent: FilterIcon },
    filterSolid: { IconComponent: FilterSolidIcon },
    flag: { IconComponent: FlagIcon },
    fontSize: { IconComponent: FontSizeIcon },
    formatAlignList: { IconComponent: FormatAlignListIcon },
    formatBold: { IconComponent: FormatBoldIcon },
    formatItalics: { IconComponent: FormatItalicsIcon },
    formatList: { IconComponent: FormatListIcon },
    formatUnderline: { IconComponent: FormatUnderlineIcon },
    hamburgerMenu: { IconComponent: HamburgerMenuIcon },
    image: { IconComponent: ImageIcon },
    info: { IconComponent: InfoIcon },
    infoCircleSolid: { IconComponent: InfoCircleSolidIcon },
    key: { IconComponent: KeyIcon },
    language: { IconComponent: LanguageIcon },
    link: { IconComponent: LinkIcon },
    lock: { IconComponent: LockIcon },
    lockSolid: { IconComponent: LockSolidIcon },
    logout: { IconComponent: LogoutIcon, supportsRTL: true },
    menu: { IconComponent: MenuIcon },
    navArchive: { IconComponent: NavArchiveIcon },
    navAssessments: { IconComponent: NavAssessmentsIcon },
    navAuditTrail: { IconComponent: NavAuditTrailIcon },
    navClientManagement: { IconComponent: NavClientManagementIcon },
    navCloseOut: { IconComponent: NavCloseOutIcon },
    navConfiguration: { IconComponent: NavConfigurationIcon },
    navConsent: { IconComponent: NavConsentIcon },
    navCube: { IconComponent: NavCubeIcon },
    navData: { IconComponent: NavDataIcon },
    navDataTransfer: { IconComponent: NavDataTransferIcon },
    navDeployment: { IconComponent: NavDeploymentIcon },
    navHelp: { IconComponent: NavHelpIcon },
    navLibraryManagement: { IconComponent: NavLibraryManagementIcon },
    navLog: { IconComponent: NavLogIcon },
    navParticipants: { IconComponent: NavParticipantsIcon },
    navProtocol: { IconComponent: NavProtocolIcon },
    navQueries: { IconComponent: NavQueriesIcon },
    navSchedule: { IconComponent: NavScheduleIcon },
    navScreenshot: { IconComponent: NavScreenshotIcon },
    navSites: { IconComponent: NavSitesIcon },
    navStudySetup: { IconComponent: NavStudySetupIcon },
    navTeam: { IconComponent: NavTeamIcon },
    navTodo: { IconComponent: NavTodoIcon },
    navTranslations: { IconComponent: NavTranslationsIcon },
    navUserManagement: { IconComponent: NavUserManagementIcon },
    navUsers: { IconComponent: NavUsersIcon },
    navWorkflows: { IconComponent: NavWorkflowsIcon },
    navWrenchScrewdriver: { IconComponent: NavWrenchScrewdriverIcon },
    notification: { IconComponent: NotificationIcon },
    orderedList: { IconComponent: OrderedListIcon },
    packageTruck: { IconComponent: PackageTruckIcon },
    pencilSolid: { IconComponent: PencilSolidIcon },
    preview: { IconComponent: PreviewIcon },
    profile: { IconComponent: ProfileIcon },
    question: { IconComponent: QuestionIcon, supportsRTL: true },
    rectangleStack: { IconComponent: RectangleStackIcon },
    remove: { IconComponent: RemoveIcon },
    save: { IconComponent: SaveIcon },
    search: { IconComponent: SearchIcon },
    send: { IconComponent: SendIcon },
    sendSolid: { IconComponent: SendSolidIcon },
    settings: { IconComponent: SettingsIcon },
    share: { IconComponent: ShareIcon },
    sortDown: { IconComponent: SortDownIcon },
    sortUp: { IconComponent: SortDownIcon, verticalReverse: true },
    sparkles: { IconComponent: SparklesIcon },
    sparklesSolid: { IconComponent: SparklesSolidIcon },
    squares: { IconComponent: SquaresIcon },
    squaresSolid: { IconComponent: SquaresSolidIcon },
    statusInProgress: { IconComponent: StatusInProgressIcon },
    statusInReview: { IconComponent: StatusInReviewIcon },
    statusNotStarted: { IconComponent: StatusNotStartedIcon },
    statusReady: { IconComponent: StatusReadyIcon },
    stopCircle: { IconComponent: StopCircleIcon },
    success: { IconComponent: SuccessIcon },
    successSolid: { IconComponent: SuccessSolidIcon },
    time: { IconComponent: TimeIcon },
    undo: { IconComponent: UndoIcon },
    unorderedList: { IconComponent: UnorderedListIcon },
    upload: { IconComponent: UploadIcon },
    video: { IconComponent: VideoIcon },
    warning: { IconComponent: WarningIcon },
    window: { IconComponent: WindowIcon },
    xCircle: { IconComponent: XCircleIcon },
    xCircleSolid: { IconComponent: XCircleSolidIcon },
};
//# sourceMappingURL=icon.map.js.map